/* eslint-disable react/no-did-update-set-state */

import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import get from 'lodash.get'
import MediaQuery from 'react-responsive'
import { Helmet } from 'react-helmet'
import queryString from 'query-string'

import Col from '../../../../components/col'
import Row from '../../../../components/row'

import { translate } from '../../../../helpers/stringHelpers'

import Button from '../../../../components/button'
import Modal from '../../../../components/modal'
import ModalHeader from '../../../../components/modalHeader'
import SocialLinks from '../../../../components/socialLinks'
import Carousel from '../../../../components/carousel'
import LoginLink from '../../../../components/loginLink'
import ListingInfoSingle from '../../../../components/listingInfoSingle'
import Card from '../../../../components/card'
import CardBody from '../../../../components/cardBody'
import AttachmentList from '../../../../components/attachmentList'
import ConfigContext from '../../../../contexts/configContext'
import ListingSale from '../../../../components/listingSale'
import StripeCheckoutButton from '../../../../components/stripeCheckoutButton'
import YouTube from 'react-youtube'
import PlayButton from '../../../../components/playButton'
import store from 'store2'
import ContactSellerModal from '../../../../components/contactSellerModal'

export class TimedSingle extends Component {
  static contextType = ConfigContext

  constructor () {
    super()
    this.state = {
      isGalleryOpen: false,
      isContactOpen: false
    }
    this.handleToggleGallery = this.handleToggleGallery.bind(this)
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.listingUuid !== this.props.listingUuid) {
      this.setState({
        isGalleryOpen: false
      })
    }
  }

  handleToggleGallery () {
    this.setState({
      isGalleryOpen: !this.state.isGalleryOpen
    })
  }

  handleDescriptionLinkClick = () => {
    const el = document.getElementById('sale-info__content--description')
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }

  generateVideoThumb = (title, videoId) => (
    <button
      className='a11y__interactive--button media--video'
      onClick={this.handleToggleGallery}
      aria-label={`${translate('JspPublicCodes-JSP_LISTING_VIEW_VIDEO')} ${title}`}
      key={`videoThumbnail${videoId}`}
    >
      <img
        alt={`${title} ${translate('JspPublicCodes-JSP_LISTING_VIDEO_THUMBNAIL')}`}
        className='img-responsive'
        src={`//img.youtube.com/vi/${videoId}/hqdefault.jpg`}
      />
      <PlayButton />
    </button>
  )

  render () {
    const { uuid: auctionUuid } = this.props

    const listingUuid = this.props.listingUuid
    const listing = this.props.listings[listingUuid]
    if (!listing || !listing.auctionUuid) return null
    const isGroup = listing.groupedItems?.length > 0
    // the auctionUuid passed in via props may not be accurate, due to consolidated marketplaces containing multiple auctions
    const realAuctionUuid = listing.auctionUuid

    const groupedImagesUuids = listing.groupedItems
      ?.map(groupedItemUuid => this.props.listings[groupedItemUuid])
      .sort((a, b) => a.lotNumber - b.lotNumber)
      .reduce((acc, listing) => acc.concat(listing.images[0]), [])

    const groupedImages = groupedImagesUuids
      ?.map(imageUuid => get(this.props, `attachments.${imageUuid}`))
      .filter(image => !!image)
    const images = listing.images
      .map(imageUuid => get(this.props, `attachments.${imageUuid}`))
      .filter(image => !!image)

    const registration = this.props.userUuid && this.props.registrantsByUserUuid[realAuctionUuid]?.[this.props.userUuid]
    const auction = this.props.auctions[realAuctionUuid] || {}
    const depositPayableOnline = auction.depositPayableOnline || false

    const pageURL = get(window, 'location.href')
    const listingUuids = this.props.listingUuids
    const listingIndex = listingUuids.indexOf(listingUuid)
    const query = queryString.parse(this.props.location.search)
    const pageSize = parseInt(query.ic) || parseInt(store.get('bidJS__items-per-page')) || this.props.itemsPerPageDefault

    const auctionQuery = queryString.stringify(Object.assign({}, query, {
      focus: listingUuid
    }))

    const nextQuery = queryString.stringify(Object.assign({}, query, {
      page: Math.floor((pageSize + listingIndex + 1) / pageSize)
    }))

    const prevQuery = queryString.stringify(Object.assign({}, query, {
      page: Math.floor((pageSize + listingIndex - 1) / pageSize)
    }))

    const previousListingUuid = listingIndex && listingUuids[listingIndex - 1]
    const nextListingUuid = listingUuids[listingIndex + 1]

    const videoIds = listing.videos
      ? listing.videos
        .map(videoUuid => this.props.attachments[videoUuid]?.publicId)
        .filter(videoId => !!videoId)
      : []

    const generateVideoThumb = this.generateVideoThumb.bind(null, listing.title)

    const handleContactClick = () => this.setState({
      isContactOpen: true
    })

    const gallery = (isModal = false, isMobile = false) => {
      const imagesArray = isGroup ? groupedImages : images
      return ([
      <Carousel
        showSlideCount
        slidesToDisplay={1}
        key={`carousel-gallery-${isModal}-${isMobile}`}
        className='listings__carousel--primary'
        hasThumbs
        hasZoom={isMobile || isModal}
        images={imagesArray.map(image => ({
          src: image.publicId,
          label: `${image.title} - ${listing.title}`,
          onClick: isMobile || isModal
            ? null
            : this.handleToggleGallery
        }))}
        childThumbs={videoIds.map(generateVideoThumb)}
      >
        {videoIds.map(videoId => !isMobile && !isModal
          ? generateVideoThumb(videoId)
          : (
              <YouTube
                key={`video${videoId}`}
                videoId={videoId}
                containerClassName='youtubeContainer'
                opts={{
                  height: 240,
                  width: 320
                }}
              />
            )
        )}
      </Carousel>
      ])
    }

    const _getRegistrationUrl = () => {
      let url = this.props.isRegisterModuleEnabled === true
        ? `/auctions/${realAuctionUuid}/register`
        : this.props.isRegisterModuleEnabled
          ? this.props.isRegisterModuleEnabled.replace(/%AUCTION_ID%/gi, realAuctionUuid)
          : null
      url += `?redirect=${this.props.location.pathname}`
      return url
    }

    const {
      hasCustomTitle,
      hasCustomMetaDescription
    } = this.context

    const auctionUrlBase = auctionUuid === 'marketplace' ? '/marketplace' : `/auctions/${auctionUuid}`

    return (
      <section aria-label='Listing View' className='listing-single'>
        <Helmet>
          {hasCustomTitle
            ? <title>{listing.title} {translate('SEOCodes_SITE_SEO_ON_AUCTION')} | {translate('SEOCodes_SITE_SEO_DEFAULT_TITLE')}</title>
            : null}
          {hasCustomMetaDescription
            ? <meta name='description' content={listing.description} />
            : null}
        </Helmet>
        <div className='listing-single-nav'>
          <Link className='listing-single-nav__item listing-single-nav__item--all' to={`${auctionUrlBase}?${auctionQuery}`}>
            &laquo; {translate('JspPublicCodes_JSP_AUCTION_VIEW_ALL_LISTINGS')}
          </Link>
          {previousListingUuid
            ? (
              <Link className='listing-single-nav__item listing-single-nav__item--previous' to={`${auctionUrlBase}/listings/${previousListingUuid}?${prevQuery}`}>
                &lsaquo; {translate('JspPublicCodes_JSP_AUCTION_PREV_LISTING')}
              </Link>
              )
            : null}
          {nextListingUuid
            ? (
              <Link className='listing-single-nav__item pull-right listing-single-nav__item--next' to={`${auctionUrlBase}/listings/${nextListingUuid}?${nextQuery}`}>
                {translate('JspPublicCodes_JSP_AUCTION_NEXT_LISTING')} &rsaquo;
              </Link>
              )
            : null}
        </div>
        <Row className='listing-details'>
          {images.length || videoIds.length || groupedImages.length
            ? (
              <Col xs={12} sm={7} className='listing-details__imagery' key={`listing${listingUuid}`}>
                <MediaQuery minDeviceWidth={768} key='primary-image__container--desktop'>
                  {gallery(false, false)}
                </MediaQuery>
                <MediaQuery maxDeviceWidth={767} key='primary-image__container--mobile'>
                  {gallery(false, true)}
                </MediaQuery>
              </Col>
              )
            : null}
          <Col xs={12} sm={5} key={`listing${listingUuid}__info`}>
            <Card
              className='timed-listing timed-listing--single'
              id={`timed-listing__${listing.lotNumber}--single`}
            >
              <ListingInfoSingle
                auctionUuid={auctionUuid}
                listingUuid={listingUuid}
                onDescriptionLinkClick={listing.description ? this.handleDescriptionLinkClick : null}
                query={this.props.location.search}
              />
              <ListingSale
                currentLanguageCode={this.props.currentLanguageCode}
                hasStarted={this.props.hasStarted}
                listingUuid={listingUuid}
              />
            </Card>
            <div className='listing__single--other-actions'>
              {this.props.socialLinks
                ? (
                  <div className='text-right social social__container'>
                    <strong className='text-muted social__label'>{translate('JspPublicCodes_JSP_AUCTION_SHARE')}</strong>
                    <SocialLinks
                      className='social__links'
                      url={pageURL}
                      title={listing.title}
                      description={listing.description}
                      {...this.props.socialLinks}
                    />
                  </div>
                  )
                : null}
              {!registration && !this.props.auctionHasEnded
                ? (
                  <LoginLink
                    isLoginModuleEnabled={this.props.isLoginModuleEnabled}
                    redirectUrl={_getRegistrationUrl()}
                    render={(url, isAbsolute) => (
                      <Button size='sm' block color='primary' href={isAbsolute && url} id='auction__action--register' to={!isAbsolute && url}>
                        {translate('JspPublicCodes_JSP_AUCTION_REGISTRATION')}
                      </Button>
                    )}
                  />
                  )
                : registration && (registration.status === 'ISSUE_WITH_DEPOSIT' || registration.status === 'AWAITING_DEPOSIT')
                  ? (
                    <StripeCheckoutButton
                      apiBaseUrl={this.props.apiBaseUrl}
                      clientId={this.props.clientId}
                      auctionId={auction.id}
                      userId={this.props.userId}
                      depositPayableOnline={depositPayableOnline}
                      block
                      id='auction__action--deposit'
                    >
                      {translate('AuctionRegistrantStatus_AWAITING_DEPOSIT')}
                    </StripeCheckoutButton>
                    )
                  : null}

              <Button size='sm' block color='info' onClick={this.props.onToggleSaleInformationModal} id='auction__action--sale-info'>
                {translate('JspPublicCodes_JSP_AUCTION_SALE_INFORMATION_VIEW')}
              </Button>
              <Button size='sm' block color='secondary' onClick={this.props.onToggleTermsModal} id='auction__action--terms-info'>
                {translate('JspPublicCodes_JSP_AUCTION_TERMS_INFORMATION_VIEW')}
              </Button>
              {listing.contactSeller
                ? (
                  <Button size='sm' block onClick={handleContactClick} id='auction__action--contact'>
                    {translate('JspPublicCodes_JSP_BIDDING_CONTACT_SELLER')}
                  </Button>
                  )
                : null}
            </div>
            <ContactSellerModal
              isOpen={this.state.isContactOpen}
              listingUuid={listingUuid}
              onClose={() => this.setState({
                isContactOpen: false
              })}
            />
            {listing.documents?.length
              ? (
                <Card className='listing-downloads'>
                  <CardBody>
                    <h3 className='h4 listing-downloads__heading'>{translate('JspPublicCodes_JSP_LISTING_ATTACHMENTS')}</h3>
                    <AttachmentList
                      classNamePrefix='listing-downloads'
                      documents={listing.documents.map(documentUuid => this.props.attachments[documentUuid])}
                    />
                  </CardBody>
                </Card>
                )
              : null}
          </Col>
        </Row>
        {listing.description
          ? (
            <section>
              <h2 className='h3'>{translate('JspPublicCodes_JSP_DESCRIPTION')}</h2>
              <p id='sale-info__content--description' dangerouslySetInnerHTML={{ __html: listing.description }} />
            </section>
            )
          : null}
        {images.length || videoIds.length || groupedImagesUuids.length
          ? (
            <MediaQuery minDeviceWidth={768}>
              <Modal className='listing-modal' size='lg' isOpen={this.state.isGalleryOpen} onClose={this.handleToggleGallery}>
                <ModalHeader onClose={this.handleToggleGallery}>
                  {listing.title}
                </ModalHeader>
                {gallery(true, true)}
              </Modal>
            </MediaQuery>
            )
          : null}
      </section>
    )
  }
}

TimedSingle.propTypes = {
  currentLanguageCode: PropTypes.string,
  attachments: PropTypes.object.isRequired,
  auctions: PropTypes.object.isRequired,
  bids: PropTypes.object.isRequired,
  apiBaseUrl: PropTypes.string,
  onToggleTermsModal: PropTypes.func.isRequired,
  hasStarted: PropTypes.bool,
  auctionHasEnded: PropTypes.bool,
  clientId: PropTypes.string,
  informations: PropTypes.object.isRequired,
  isLoginModuleEnabled: PropTypes.bool.isRequired,
  isMarketplace: PropTypes.bool.isRequired,
  isRegisterModuleEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  itemsPerPageDefault: PropTypes.number.isRequired,
  listings: PropTypes.object.isRequired,
  listingUuid: PropTypes.string.isRequired,
  listingUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string.isRequired
  }),
  onToggleSaleInformationModal: PropTypes.func.isRequired,
  registrantsByUserUuid: PropTypes.object.isRequired,
  socialLinks: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    email: PropTypes.bool,
    facebook: PropTypes.bool,
    messenger: PropTypes.bool,
    twitter: PropTypes.bool,
    pinterest: PropTypes.bool,
    whatsapp: PropTypes.bool,
    linkedin: PropTypes.bool
  })]),
  userId: PropTypes.number,
  userUuid: PropTypes.string,
  uuid: PropTypes.string.isRequired
}

export function mapStateToProps (state) {
  return {
    currentLanguageCode: state.config.currentLanguageCode,
    attachments: state.attachments.attachments,
    auctions: state.auctions.auctions,
    bids: state.bids.bids,
    apiBaseUrl: state.config.input.config.apiBase,
    informations: state.auctions.information,
    isLoginModuleEnabled: state.config.input.modules.login,
    isRegisterModuleEnabled: state.config.input.modules.register,
    itemsPerPageDefault: state.config.input.options.itemsPerPageDefault,
    listings: state.lots.listings,
    registrantsByUserUuid: state.registrations.registrantIdsByUserUuidByAuction,
    socialLinks: state.config.input.options.socialLinks,
    userId: state.users.user.id,
    userUuid: state.users.user.uuid,
    clientId: state.config.input.config.clientId
  }
}

export default withRouter(connect(mapStateToProps)(TimedSingle))
